import React from 'react';
import Upload from '../assets/images/illustration-upload-cloud.svg';

export default () => {
  return <img src={Upload} alt="Upload" />;
};
